import { themeVariables } from "Components/theme";
import { DivWithTooltip } from "Components/withPopover";
import classNames from "classnames";
import React, { useCallback, useMemo } from "react";
import styles from "./sidebarMenuToggler.module.css";
const style = {
    position: "absolute",
    bottom: "50%",
    width: 0,
    height: 0,
    visibility: "hidden",
    right: "-0.7em"
};
export default function SidebarMenuToggler(props) {
    const handleSidebarMenuTogglerClick = useCallback(() => {
        props.onExpandedChanged && props.onExpandedChanged(!props.isExpanded);
    }, [props.onExpandedChanged, props.isExpanded]);
    const togglerStyle = useMemo(() => ({
        display: "grid",
        alignContent: "center",
        justifyContent: "center",
        padding: "0.7em 0.3em 0.7em 0em",
        width: "1.2em",
        backgroundColor: "#dfe5ec",
        borderTopRightRadius: "1.5em",
        borderBottomRightRadius: "1.5em"
    }), []);
    return (React.createElement(DivWithTooltip, { style: style, popoverContent: React.createElement("i", { className: classNames("font-h5 font-bold clickable text-default", props.isExpanded ? "icon-arrow-left" : "icon-arrow-right", styles.icon), style: togglerStyle, onClick: handleSidebarMenuTogglerClick }), popoverClassName: "transparent-popover opacity-0_85", hideEvent: "none", showEvent: "none", defaultVisible: true, visible: true, key: props.isExpanded ? "1" : "0", zIndex: parseInt(themeVariables["zindex-navbar"]) }));
}
SidebarMenuToggler.defaultProps = {
    bgColor: "navbar-bg-lightest"
};
